interface SpecimenIdentifier {
  id?: string;
  number: string;
}

export function allowsGrossingSpecimenIdentifierEdits(
  statusName?: string
): boolean {
  return statusName === "Pending Grossing" || statusName === "Grossing";
}

export function preservePersistedSpecimenIdentifiers<
  T extends SpecimenIdentifier
>(specimens: T[], persisted: SpecimenIdentifier[]): T[] {
  const identifiers = new Map(
    persisted.map((specimen) => [specimen.id, specimen.number])
  );
  return specimens.map((specimen) => {
    const number = specimen.id ? identifiers.get(specimen.id) : undefined;
    return number === undefined ? specimen : { ...specimen, number };
  });
}

export function getExpectedSpecimenIdentifiers(
  persisted: SpecimenIdentifier[]
): Record<string, string> {
  return Object.fromEntries(
    persisted
      .filter((specimen) => specimen.id)
      .map((specimen) => [specimen.id!, specimen.number])
  );
}
